import moment from 'moment';
import WorkStatus from '@/dossier/constants/WorkStatus';
import Severity from '@/shared/constants/Severity';
import Tag from '@/shared/models/Tag';
import User from '@/shared/models/User';
import ExecutionStatus from '../constants/ExecutionStatus';
import JobType from '../constants/JobType';
import OrderStatus from '../constants/OrderStatus';
import PriceApprovalStatus from '../constants/PriceApprovalStatus';
import WarrantyStatus from '../constants/WarrantyStatus';
import { JobId } from './AbstractJob';

export class LinkedJob {
  id!: JobId;
  sequenceNumber = 0;
  description = '';
}

export default class JobMaster extends LinkedJob {
  createdOn = moment();
  type = JobType.JOB;
  needFollowUp = false;
  workStatus = WorkStatus.NOT_STARTED;
  executionStatus = ExecutionStatus.NOT_GIVEN;
  orderStatus = OrderStatus.NOT_GIVEN;
  hasOrderSignature = false;
  priceApprovalStatus = PriceApprovalStatus.NOT_GIVEN;
  warranty = WarrantyStatus.NO_WARRANTY;
  pauseReason: Tag | null = null;
  tags: Array<Tag> = [];
  mediaCount = 0;
  commentCount = 0;
  diagnosticCount = 0;
  assignedTo: User | null = null;
  severity: Severity | null = null;
  checklistStatus: Severity | null = null;
  linkedJob: LinkedJob | null = null;

  getTitle(): string {
    return `${this.sequenceNumber}. ${this.description}`;
  }

  start(): void {
    this.workStatus = WorkStatus.BEING_HANDLED;
    this.pauseReason = null;
  }

  stop(reason: Tag | null = null): void {
    this.workStatus = WorkStatus.ON_HOLD;
    this.pauseReason = reason;
  }
}